const append = (formData, key, value, appendNullValues = false) => {
  if (value === true || value === false) {
    formData.append(key, value)
  } else if (value || appendNullValues) {
    formData.append(key, value || '')
  } else {
    formData.delete(key)
  }
}

const appendFile = (formData, key, value, fileName) => {
  if (value) {
    formData.append(key, value, fileName)
  } else {
    formData.delete(key)
  }
}

const appendObject = (formData, objectParam, appendNullValues = false) => {
  let object = objectParam || {}
  for (const [key, value] of Object.entries(object)) {
    append(formData, key, value, appendNullValues)
  }
}

export default {
  append,
  appendFile,
  appendObject
}
